import Store from "../Store/Store";
import Constants from "../Action/Constants";

class History {

  protected steps: number = 0;
  protected history: string[] = [];
  protected limit: number = 50;
  protected urlBeforeSearch: string | undefined = undefined;
  protected stepBeforeSearch: number = 0;

  public listen(browserHistory: any): void {
    // We should insert the link directly after issuing F5 on browser.
    const localStorageHistory = sessionStorage.getItem("history") && 
                                [...JSON.parse(sessionStorage.getItem("history"))].reverse();
    
    if (this.getHistory().length === 0
          && location.pathname !== "/"
          && !location.pathname.includes("auth")
          && !!localStorageHistory 
          && localStorageHistory[localStorageHistory.length - 1] !== location.pathname) {
      this.insert(location.pathname);
    }

    // article about how to fix scroll position on page changing
    // https://github.com/ReactTraining/react-router/issues/2144#issuecomment-153899046

    // Then, listen for each change.
    browserHistory.listen(location => {
      // we should clear error messages when change url
      Store.getConfigurator().dispatch({
        type: Constants.ALERT_HIDE
      });

      // Use setTimeout to make sure this runs after React Router's own listener
      setTimeout(() => {
        // Keep default behavior of restoring scroll position when user:
        // - clicked back button
        // - clicked on a link that programmatically calls `history.goBack()`
        // - manually changed the URL in the address bar (here we might want
        // to scroll to top, but we can't differentiate it from the others)

        if (location.action === "POP") {
          if (this.getHistory().includes(location.pathname)) {
            if (this.getHistory().length > 1) {
              this.getHistory().shift();
              
              this.steps = this.getHistory().length;
              this.updateBreadcrumbs(this.getHistory());
              this.updateSessionStorageHistory(this.getHistory());
              return;
            } else if (location.action === "POP") {
              // if we do not have previous page we should redirect user to start point
              return  browserHistory.push("/");
            }
          }
        }

        if (location.action === "REPLACE") {
          return this.replaceCurrent(location.pathname);
        }

        // push path to history stack
        this.insert(location.pathname);

        // In all other cases, check fragment/scroll to top
        const hash = window.location.hash;
        if (hash) {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({block: "start", behavior: "smooth"});
          }
        } else {
          window.scrollTo(0, 0);
        }
      });
    });
  }

  public insert(path: string): void {
    if (location.pathname === "/" || location.pathname.includes("auth")) {
      return;
    }

    // should start history from root
    if (
          location.pathname.includes("app/units")
          || location.pathname.includes("app/properties")
          || location.pathname.includes("app/contacts")
          || location.pathname.includes("app/companies")
          || (location.pathname.includes("app/finance") && !/[0-9]/.test(location.pathname))
          || location.pathname.includes("app/dashboard")
          || location.pathname.includes("app/mails")
    ) {
      this.history = [];
    }

    // Push the current URL the front of array if current url !== previous url
    if (this.getHistory()[0] !== path) {
      this.getHistory().unshift(path);
    }

    // Increase the amount of steps
    this.steps = this.getHistory().length;

    // Limit the browsing history
    if (this.getHistory().length > this.limit) {
      this.getHistory().pop();
    }
    
    this.updateBreadcrumbs(this.getHistory());
    this.updateSessionStorageHistory(this.getHistory());
  }

  public replaceCurrent(path: string): void {
    // Replace the current URL if current url !== previous url
    if (this.getHistory()[0] !== path) {
      this.getHistory()[0] = path;
    }

    this.updateBreadcrumbs(this.getHistory());
    this.updateSessionStorageHistory(this.getHistory());
  }

  public updateBreadcrumbs = (history) => {
    Store.getConfigurator().dispatch({
      type: Constants.UPDATE_BREADCRUMBS,
      payload: {
        breadcrumbs: [...history]
      }
    });
  }

  public updateSessionStorageHistory = (history) => {
    sessionStorage.setItem("history", JSON.stringify(history));
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousPage(): string {
    return this.getHistory()[1];
  }
}

export default new History();
